import { SystemBase } from "@inter-ikea-core/core-toolbox";
import { ComponentIds, } from "@inter-ikea-core/core";
import { getMountingRails, resizeMountingRailModel, } from "../functions/MountingRails";
import { getUprights, hasUprights } from "../utils/sectionsHelpers";
import { getViewerObject } from "@inter-ikea-storagetwo/range/dist/functions/componentGetters";
import { NO_UPRIGHTS } from "../constants/errors";
export default class UndoRedoListenerSystem extends SystemBase {
    constructor(core, viewer) {
        super(ComponentIds.IS_LOADING_SNAPSHOT_COMPONENT_ID);
        this.core = core;
        this.viewer = viewer;
        this.doingChangesOnComponent = [];
        this.systemsBeforeMe = null;
        this.systemsAfterMe = null;
        this.id = "UndoRedoListenerSystem";
        this.resizeMountingRail = (mountingRail) => {
            const viewerObject = getViewerObject(mountingRail);
            const { rightUpright } = getUprights(mountingRail);
            if (!rightUpright)
                throw new Error(NO_UPRIGHTS);
            resizeMountingRailModel(mountingRail, rightUpright, viewerObject, this.viewer);
        };
    }
    onRemoveComponent(_entity, _newComponent) {
        getMountingRails(this.core)
            .filter(hasUprights)
            .forEach(this.resizeMountingRail);
    }
}
